module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":["rx","Subject"],"commonjs":"rxjs/Subject","commonjs2":"rxjs/Subject","amd":"rxjs/Subject"}
// module id = 5
// module chunks = 0